export const UPDATE = 'UPDATE_USER';

export const UPDATERIDER = 'UPDATERIDER';

export const CLOSE = 'CLOSE_USER';

export const UPDATE_TO_LOCALSTORAGE = "USER_ORDER_DATA";

export const UPDATE_TO_LOCALSTORAGE_RIDER = "RIDER_FORM_DATA";

export const SAVE_RIDER_TO_SERVER = "SAVE_RIDER_TO_SERVER";

export const USER_AUTHENTICATION_DATA = "USER_AUTHENTICATION_DATA";